// -----------------------------------------------------------------------------
// AIDAS Platform — main.tsx (Vite entry point)
// ✅ Wraps everything inside <BrowserRouter> to restore routing context
// ✅ Fixes "useLocation() may be used only in the context of a <Router> component"
// -----------------------------------------------------------------------------

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { ThemeProvider } from "./context/ThemeContext";
import { AuthProvider } from "./context/AuthContext";
import { NotificationProvider } from "./context/NotificationContext";
import { AlertProvider } from "./context/AlertContext";
import { WebSocketProvider } from "./context/WebSocketContext";
import SessionRevokedModal from "./components/SessionRevokedModal";
import SessionExpiryModal from "./components/SessionExpiryModal";
import { AppToaster } from "./components/core";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AuthProvider>
        <ThemeProvider>
          {/*
            WebSocketProvider:
            • Inside AuthProvider  → token is available when connecting
            • Outside AlertProvider → AlertContext can subscribe to ALERT_CREATED
            • Outside SessionRevokedModal → it can subscribe to SSA_LOGIN_REQUEST / SESSION_REVOKED
            onReconnect: fires a synthetic WS_RECONNECTED message so AlertContext
            can do a one-time full fetch to reconcile missed messages during the gap.
          */}
          <WebSocketProvider>
            <NotificationProvider>
              <AlertProvider>
                <App />
                <SessionRevokedModal />
                <SessionExpiryModal />
              </AlertProvider>
            </NotificationProvider>
          </WebSocketProvider>
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
    <AppToaster />
  </React.StrictMode>
);
